import { useQuery } from '@apollo/client';
import { Data } from '../models/dealer';
import { BY_TERM } from '../utils/graphql/dealers';
import { checkIfPostalCode } from '../utils/checkIfPostalCode';
import { toISO3CountryCode } from '../utils/i18n';

export default function useSearchByTerm(text: string, countryCode?: string, filters?: string[]) {
  const { error, loading, data } = useQuery<
    Data,
    { searchTerm: string; country?: string; services?: string }
  >(BY_TERM, {
    fetchPolicy: 'no-cache',
    variables: {
      searchTerm: text,
      ...(countryCode && { country: toISO3CountryCode(countryCode) }),
      ...(filters?.length && { services: filters.join() }),
    },
    skip: text?.length < 1 || checkIfPostalCode(text, countryCode),
  });

  return {
    error,
    loading,
    dealersResult: data?.dealersByTerm?.dealers,
  };
}
